import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.Squawkeye,
  voices: {
    main: {
      description:
        "dry midwestern tenor, laconic archer sarcasm, relaxed drawl that snaps into focus, unpolished field recorder intimacy, wry smile in every line",
      seed: 10361,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      { id: "select_1", text: "Once an Avenger, always an Avenger!" },
      { id: "select_2", text: "Squakeye's back. It's been a while…" },
      { id: "select_3", text: "Squakeye is in position." },
      { id: "select_4", text: "Squakeye to team: I'm in the field." },
      {
        id: "select_5",
        text: "Someone's gonna have to teach 'em some manners.",
      },
    ],
    spawn: [
      {
        id: "spawn_1",
        text: "Enough with the arrows. Time to give the old sword a workout…",
      },
      {
        id: "spawn_2",
        text: "Thanks, you two! My blade was due for an upgrade!",
      },
      { id: "spawn_3", text: "A psychic upgrade? Don't mind that one bit…" },
      {
        id: "spawn_4",
        text: "Keep those Psionic Arrows coming, Sai, and I'll keep 'em firing!",
      },
      {
        id: "spawn_5",
        text: "I was out there, alone. And I… really needed someone to argue with.",
      },
      { id: "spawn_6", text: "What's wrong with purple? I like purple." },
      { id: "spawn_7", text: "Wait, who took my boomerang arrows?" },
      {
        id: "spawn_8",
        text: "I gotta admit, it's fun getting in the lab and coming up with new arrowheads.",
      },
      {
        id: "spawn_9",
        text: "When you're surrounded by gods and cosmic wizards, you gotta keep your head.",
      },
      {
        id: "spawn_10",
        text: "You know what my real superpowers are? Patience and common sense.",
      },
      {
        id: "spawn_11",
        text: "One of these days, I need to sit down with Rocket and exchange ideas.",
      },
      {
        id: "spawn_12",
        text: "If the world didn't need super heroes, I'd work at carnival.",
      },
      {
        id: "spawn_13",
        text: "I think I'm pretty relatable, compared to Namor or someone like that.",
      },
      { id: "spawn_14", text: "I never miss, I CAN'T miss." },
      {
        id: "spawn_15",
        text: "Becoming an Avenger was the best thing I've ever done.",
      },
      {
        id: "spawn_16",
        text: "Anybody can shoot a gun. A bow, now… that takes skill.",
      },
      {
        id: "spawn_17",
        text: "I think I was chosen to do some good in the world.",
      },
      {
        id: "spawn_18",
        text: "My years away from the Avengers taught me how much they meant to me.",
      },
      {
        id: "spawn_19",
        text: "Every fight, I say to myself: I might go down, but I'll go down swingin'.",
      },
      { id: "spawn_20", text: "To be a super hero, gotta be an optimist." },
      { id: "spawn_21", text: "Whatever we're gonna do, let's do it now." },
      {
        id: "spawn_22",
        text: "We're fighting an army of robots, and I have a bow and arrow.",
      },
      {
        id: "spawn_23",
        text: "None of this makes sense. But I'm going back out there because it's my job.",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "I got some unfinished business." },
      { id: "respawn_2", text: "We are done when I SAY we're done!" },
      { id: "respawn_3", text: "Hey, at least my quiver's refilled~" },
      { id: "respawn_4", text: "Still breathing, still fighting." },
      { id: "respawn_5", text: "Think I twisted my shoulder." },
      { id: "respawn_6", text: "It's me again." },
      { id: "respawn_7", text: "Got some unfinished business." },
      { id: "respawn_8", text: "Let's try this again." },
    ],
    ult_ally: [{ id: "ult_ally", text: "Here's how you shoot!" }],
    ult_enemy: [{ id: "ult_enemy", text: "Woo…I never miss!" }],
    ability2: [
      { id: "ability2_1", text: "Nowhere to hide." },
      { id: "ability2_2", text: "Sonic boom." },
      { id: "ability2_3", text: "Punching a hole." },
    ],
    ability1: [
      { id: "ability1_1", text: "Hack and slash!" },
      { id: "ability1_2", text: "Making the cut!" },
      { id: "ability1_3", text: "Looking sharp!" },
    ],
    kill: [
      { id: "kill_1", text: "You're too loud." },
      { id: "kill_2", text: "I am too good at this." },
      { id: "kill_3", text: "Was that MY arrow?" },
      { id: "kill_4", text: "It's too easy when you never miss." },
      { id: "kill_5", text: "PLEASE gimme a challenge!" },
      { id: "kill_6", text: "Purple's not so funny now, is it?" },
      { id: "kill_7", text: "Another one for the good guys." },
      { id: "kill_8", text: "Yeah, I earned that one." },
    ],
    multikill: [
      { id: "multikill_1", text: "Triple shot!" },
      { id: "multikill_2", text: "Three straight!" },
      { id: "multikill_3", text: "KO, KO, KO." },
      { id: "multikill_4", text: "There's a handful." },
      { id: "multikill_5", text: "I got five!" },
      { id: "multikill_6", text: "Party of five." },
      { id: "multikill_7", text: "That was selfish, wasn't it?" },
      { id: "multikill_8", text: "What can I say? I don't miss." },
      { id: "multikill_9", text: "I need to be better about sharing." },
    ],
    low_hp: [
      { id: "low_hp_1", text: "Whew, that was close." },
      { id: "low_hp_2", text: "Almost too late." },
    ],
    healed: [
      { id: "healed_1", text: "Needed that boost." },
      { id: "healed_2", text: "Just what the doctor ordered." },
      { id: "healed_3", text: "That came in handy." },
      { id: "healed_4", text: "I'm in good shape now." },
    ],
  },
} satisfies VoiceScript;

export default script;
